import t from '@jetshop/intl'
import React, { useState, useEffect, useContext } from 'react'
import { styled } from 'linaria/react'
import ChannelContext from '@jetshop/core/components/ChannelContext'
import { formatPrice } from '../../Core/Util/Helpers'

export const PriceHistoryWrapper = styled('div')`
   button,
   span {
      background: none;
   }
   span {
      font-weight: 600;
   }
   position: relative;

   .price-flyout {
      background: #efefef;
      position: absolute;
      top: calc(100% + 10px);
      border-bottom: 4px solid #275077;
      max-width: 100%;
      left: 0;
      border-radius: 4px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 12px -2px,
         rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
      padding: 1rem;
      z-index: 9;
      color: black;
      h3 {
         display: block;
         font-size: 12px;
         font-family: var(--font-grotesk);
      }
      &::before {
         position: absolute;
         top: -10px;
         left: 30px;
         transform: translatex(-50%);
         content: '';
         width: 0;
         height: 0;
         border-style: solid;
         border-width: 0 10px 10px 10px;
         border-color: transparent transparent #efefef transparent;
      }
   }
   ul {
      margin: 0 0;
      font-size: 12px;
      li {
         padding: 4px 0px;
         width: 100%;
         display: flex;
         gap: 0.5rem;
         div {
            display: contents;
         }
      }
   }

   .price-history-label {
      font-family: var(--font-industry);
      font-weight: 500;
      font-size: 12px;
      cursor: pointer;
   }

   .price-history-label:hover {
      opacity: 0.8;
   }

   button {
      padding: 0;
   }
`
const getPriceHistoryWithinDateRange = (history, daysBack = 30) => {
   if (!Array.isArray(history)) return []
   const currentDate = new Date()
   const daysInMs = daysBack * 24 * 60 * 60 * 1000
   const startDate = new Date(currentDate.getTime() - daysInMs)

   return history.filter(entry => {
      if (!entry?.timestamp || typeof entry.timestamp !== 'string') return false

      const entryDate = new Date(entry.timestamp)
      if (isNaN(entryDate.getTime())) return false

      return entryDate >= startDate && entryDate <= currentDate
   })
}

export const ProductPriceHistoryCheapest = ({ selectedVariant, showVat }) => {
   const { selectedChannel } = useContext(ChannelContext)
   const [open, setOpen] = useState(false)
   const currentPrice = selectedVariant?.price?.incVat || Infinity

   const priceHistorySinceLastUpdate =
      selectedVariant?.history?.previousPrice?.filter(
         priceEntry => priceEntry?.price?.incVat !== 0
      )

   const history30DaysBack = getPriceHistoryWithinDateRange(
      priceHistorySinceLastUpdate,
      30
   )?.filter(priceEntry => priceEntry?.price?.incVat !== currentPrice)
      ?.sort((a, b) => a.price?.incVat - b?.price?.incVat)

   
   let cheapestPriceObject = null

   if (history30DaysBack?.length > 0 ) {
    cheapestPriceObject = history30DaysBack[0]
   } else {
    cheapestPriceObject = selectedVariant?.previousPrice
    ? { price: selectedVariant.previousPrice }
    : null
   }

   useEffect(() => {
      function clickOutside(event) {
         if (!event.target.closest('#priceHistory')) {
            setOpen(false)
         }
      }

      window.addEventListener('click', clickOutside)
      return () => window.removeEventListener('click', clickOutside)
   }, [])

   if (!cheapestPriceObject) {
      return <></>
   }

   return (
      <PriceHistoryWrapper id="priceHistory">
         <button onClick={() => setOpen(!open)}>
            <span className="price-history-label link link--vb">
               {t('Pricehistory')}
            </span>
         </button>
         {open && (
            <div className="price-flyout">
               <>
                  <h3 className="mb-1">
                     {t('Lowest price in the last {daysNumber} days', {
                        daysNumber: 30,
                     })}
                     :
                  </h3>
                  <h3 className="mb-1">
                     {formatPrice(
                        showVat
                           ? cheapestPriceObject?.price?.incVat
                           : cheapestPriceObject?.price?.exVat,
                        selectedChannel?.id
                     )}
                  </h3>
               </>
            </div>
         )}
      </PriceHistoryWrapper>
   )
}
